import React, { useEffect, useMemo, useState } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import Slider from 'react-slick'

import './PersonView.css'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const API_BASE = 'https://backend.alephmedia.ro/api'

const DEFAULT_PERSON = {
  id: null,
  name: 'Persoană',
  image_16_9: null,
  image_9_16: null,
  links: [],
  programs: [],
  episodes: []
}

const SOCIAL_ICONS = {
  instagram: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
    </svg>
  ),
  facebook: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
    </svg>
  ),
  youtube: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
    </svg>
  ),
  twitter: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
    </svg>
  ),
  tiktok: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
    </svg>
  ),
  linkedin: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
    </svg>
  ),
  website: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/>
      <line x1="2" y1="12" x2="22" y2="12"/>
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
    </svg>
  )
}

function getSocialIcon(label = '') {
  const lowerLabel = label.toLowerCase()
  for (const key in SOCIAL_ICONS) {
    if (lowerLabel.includes(key)) {
      return SOCIAL_ICONS[key]
    }
  }
  return SOCIAL_ICONS.website
}

function extractImage(item = {}, type) {
  if (!item) return null
  if (type === 'desktop') {
    return item.image_16_9 || item.image_9_16 || item.poster_image_16_9 || item.poster_image_9_16 || null
  }
  return item.image_9_16 || item.image_16_9 || item.poster_image_9_16 || item.poster_image_16_9 || null
}

const ArrowButton = ({ direction, onClick }) => {
  const isNext = direction === 'next'
  return (
    <button
      className={`person-view-arrow person-view-arrow-${direction}`}
      type="button"
      onClick={onClick}
      aria-label={isNext ? 'Vezi următoarele' : 'Vezi precedentele'}
    >
      {isNext ? (
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 6l6 6l-6 6" />
        </svg>
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M15 6l-6 6l6 6" />
        </svg>
      )}
    </button>
  )
}

const PersonView = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const [person, setPerson] = useState(DEFAULT_PERSON)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!id) {
      navigate('/v3.0')
    }
  }, [id, navigate])

  useEffect(() => {
    const statePerson = location.state?.person
    if (statePerson) {
      setPerson({ ...DEFAULT_PERSON, ...statePerson })
      setLoading(false)
      return
    }

    async function loadPerson() {
      if (!id) return
      setLoading(true)
      setError(null)
      try {
        const response = await fetch(`${API_BASE}/people/${id}`)
        if (!response.ok) {
          throw new Error(`Nu am putut încărca persoana. Cod: ${response.status}`)
        }
        const json = await response.json()
        if (!json.success || !json.data) {
          throw new Error('Răspuns invalid de la server.')
        }
        setPerson({ ...DEFAULT_PERSON, ...json.data })
      } catch (err) {
        console.error('loadPerson failed', err)
        setError(err.message || 'Nu am putut încărca persoana selectată.')
      } finally {
        setLoading(false)
      }
    }

    loadPerson()
  }, [id, location.state])

  const desktopImage = person.image_16_9
  const mobileImage = person.image_9_16

  const personLinks = person.links || []
  const personPrograms = person.programs || []
  const personEpisodes = person.episodes || []

  const initials = useMemo(() => {
    if (!person.name) return '?'
    const parts = person.name.trim().split(/\s+/)
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
    }
    return person.name[0].toUpperCase()
  }, [person.name])

  return (
    <div className="person-view-root">
      <div className="person-view-header">
        <button type="button" className="person-view-back" onClick={() => navigate(-1)} aria-label="Back">
          <svg width="41" height="34" viewBox="0 0 41 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.3333 21.6667L3 12.3333M3 12.3333L12.3333 3M3 12.3333H28.6667C31.142 12.3333 33.516 13.3167 35.2663 15.067C37.0167 16.8173 38 19.1913 38 21.6667C38 24.142 37.0167 26.516 35.2663 28.2663C33.516 30.0167 31.142 31 28.6667 31H26.3333" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>

      {loading && <div className="person-view-status">Se încarcă...</div>}
      {error && <div className="person-view-status person-view-status-error">{error}</div>}

      {!loading && !error && (
        <div className="person-view-content">
          <div className="person-view-hero">
            <div className="person-view-avatar">
              <picture>
                <source media="(max-width: 768px)" srcSet={mobileImage || undefined} />
                {desktopImage ? (
                  <img src={desktopImage} alt={person.name || 'Persoană'} />
                ) : mobileImage ? (
                  <img src={mobileImage} alt={person.name || 'Persoană'} />
                ) : (
                  <div className="person-view-placeholder">{initials}</div>
                )}
              </picture>
            </div>
            <h1>{person.name}</h1>
          </div>

          {!!personLinks.length && (
            <div className="person-view-links">
              {personLinks.map((link, linkIndex) => {
                const icon = getSocialIcon(link.label || '')
                return (
                  <a key={`${link.url}-${linkIndex}`} href={link.url} target="_blank" rel="noopener noreferrer" className="person-view-link-card">
                    {icon ? <span className="person-view-link-icon">{icon}</span> : null}
                    <span className="person-view-link-label">{link.label}</span>
                  </a>
                )
              })}
            </div>
          )}

          {!!personPrograms.length && (
            <section className="person-view-section person-view-section-fullwidth">
              <header className="person-view-section-header">
                <h2>Programe</h2>
              </header>
              <div className="person-view-row">
                <Slider
                  slidesToShow={6}
                  slidesToScroll={6}
                  infinite={false}
                  arrows
                  dots
                  nextArrow={<ArrowButton direction="next" />}
                  prevArrow={<ArrowButton direction="prev" />}
                  responsive={[
                    { breakpoint: 1280, settings: { slidesToShow: 5, slidesToScroll: 5 } },
                    { breakpoint: 1024, settings: { slidesToShow: 4, slidesToScroll: 4 } },
                    { breakpoint: 768, settings: { slidesToShow: 4, slidesToScroll: 4, arrows: false, dots: true } },
                    { breakpoint: 640, settings: { slidesToShow: 4, slidesToScroll: 4, arrows: false, dots: true } }
                  ]}
                >
                  {personPrograms.map((program, index) => {
                    const desktopImg = extractImage(program, 'desktop')
                    const mobileImg = extractImage(program, 'mobile') || desktopImg
                    const linkTo = `/v3.0/programs/${program.id}`
                    const linkState = { program }
                    return (
                      <Link
                        key={`program-${program.id}-${index}`}
                        to={linkTo}
                        state={linkState}
                        className="person-view-card person-view-card--link"
                      >
                        <div className="person-view-card-image">
                          <picture>
                            <source media="(max-width: 768px)" srcSet={mobileImg || undefined} />
                            <img src={desktopImg || undefined} alt={program.title || 'Program'} loading="lazy" />
                          </picture>
                        </div>
                        <div className="person-view-card-title">{program.title || 'Program'}</div>
                      </Link>
                    )
                  })}
                </Slider>
              </div>
            </section>
          )}

          {!!personEpisodes.length && (
            <section className="person-view-section person-view-section-fullwidth">
              <header className="person-view-section-header">
                <h2>Episoade</h2>
              </header>
              <div className="person-view-row">
                <Slider
                  slidesToShow={6}
                  slidesToScroll={6}
                  infinite={false}
                  arrows
                  dots
                  nextArrow={<ArrowButton direction="next" />}
                  prevArrow={<ArrowButton direction="prev" />}
                  responsive={[
                    { breakpoint: 1280, settings: { slidesToShow: 5, slidesToScroll: 5 } },
                    { breakpoint: 1024, settings: { slidesToShow: 4, slidesToScroll: 4 } },
                    { breakpoint: 768, settings: { slidesToShow: 4, slidesToScroll: 4, arrows: false, dots: true } },
                    { breakpoint: 640, settings: { slidesToShow: 4, slidesToScroll: 4, arrows: false, dots: true } }
                  ]}
                >
                  {personEpisodes.map((episode, index) => {
                    const desktopImg = extractImage(episode, 'desktop')
                    const mobileImg = extractImage(episode, 'mobile') || desktopImg
                    const programId = episode.program?.id
                    const linkTo = programId ? `/v3.0/programs/${programId}/episodes/${episode.id}` : null
                    return linkTo ? (
                      <Link
                        key={`episode-${episode.id}-${index}`}
                        to={linkTo}
                        className="person-view-card person-view-card--link"
                      >
                        <div className="person-view-card-image">
                          <picture>
                            <source media="(max-width: 768px)" srcSet={mobileImg || undefined} />
                            <img src={desktopImg || undefined} alt={episode.title || 'Episod'} loading="lazy" />
                          </picture>
                        </div>
                        <div className="person-view-card-title">{episode.title || 'Episod'}</div>
                      </Link>
                    ) : (
                      <div key={`episode-${episode.id}-${index}`} className="person-view-card">
                        <div className="person-view-card-image">
                          <picture>
                            <source media="(max-width: 768px)" srcSet={mobileImg || undefined} />
                            <img src={desktopImg || undefined} alt={episode.title || 'Episod'} loading="lazy" />
                          </picture>
                        </div>
                        <div className="person-view-card-title">{episode.title || 'Episod'}</div>
                      </div>
                    )
                  })}
                </Slider>
              </div>
            </section>
          )}
        </div>
      )}
    </div>
  )
}

export default PersonView

